<template>
    <div class="columns small-12 large-3">
        <c-form-element>
            <select
                :name="filter.name"
                :placeholder="filter.placeholder"
                :icon="true"
                @input="change"
                required>
                <option value=''
                    disabled
                    :selected="!selected">{{filter.placeholder}}</option>
                <option
                    v-for="option in filter.options"
                    :value="option.value"
                    :selected="selected === option.value"
                    >{{option.label}}</option>
            </select>
        </c-form-element>
    </div>
</template>

<script>
import CFormElement from '@components/form/Element';

export default {
    components: { CFormElement },
    props: {
        filter: {
            type: Object,
            required: true
        },
        selected: {
            default: false
        }
    },
    methods: {
        change(event) {
            this.$emit('change', {filter: this.filter, value: event.target.value});
        }
    }
}
</script>
